import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  ResendOtp,
  VerifyOtp as VerifyOtpService,
} from "../../services/auth/auth";
import { toastMessage } from "../../utils/helper";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const { verifyEmailFromAuth } = useSelector(state => state.auth)
  const [verifyEmail, setVerifyEmail] = useState(
    useSelector((state) => state.auth?.verifyEmail),
  );
  const [otpCode, setOtpCode] = useState("");
  const [sendingOtpCode, setSendingOtpCode] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [disable, setDisable] = useState(false);
  const [counter, setCounter] = useState(30);
  const {
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    criteriaMode: "firstError",
    shouldFocusError: true,
  });

  useEffect(() => {
    let timer =
      counter > 0 &&
      setInterval(() => {
        setCounter(counter - 1);
      }, 1000);

    return () => clearInterval(timer);
  }, [counter]);

  const onSubmit = async (data) => {
    try {
      setDisable(true);

      if (otpCode.length == 0) {
        setError(true);
        setErrorMessage("Please Enter Code");
      } else if (otpCode.length > 0 && otpCode.length < 4) {
        setError(true);
        setErrorMessage("Code is incomplete");
      } else {
        if (!verifyEmail) throw new Error("Email is required!");
        const response = await VerifyOtpService({
          email: verifyEmail,
          otp_code: otpCode,
        });
        let { data, message, status } = response.data;
        if (!status) {
          toastMessage("error", message);
          return;
        }
        toastMessage(
          "success",
          "Account verified successfully, now you can login!",
        );
        navigate("/");
      }
    } catch (e) {
      toastMessage("error", e.message);
    } finally {
      setDisable(false);
    }
  };

  const handleOtpChange = (otp) => {
    setOtpCode(otp);
  };

  const resendCode = async () => {
    if (sendingOtpCode) return;
    try {
      if (!verifyEmail) throw new Error("Email is required!");
      setSendingOtpCode(true);
      const response = await ResendOtp({
        email: verifyEmail,
      });
      const { data, message, status } = response.data;
      if (!status) {
        toastMessage("error", message);
        return;
      }
      setCounter(30);
      toastMessage("success", message);
    } catch (e) {
      toastMessage("error", e.message);
    } finally {
      setSendingOtpCode(false);
    }
  };

  useEffect(() => {
    const email = queryParams.get("email");
    if (email) {
      setVerifyEmail(email);
    }
  }, [queryParams]);

  return (
    <div className="authBox SignUp">
      <div className="authHeaderText">
        <h1>Verify Email</h1>
      </div>
      <Form onSubmit={handleSubmit(onSubmit)} autoComplete={"off"}>
        <Form.Group className="OtpInput-container" controlId="signInEmail">
          <OtpInput
            value={otpCode}
            onChange={(otp) => handleOtpChange(otp)}
            numInputs={4}
            isInputNum={true}
            placeholder={"----"}
            className={"OtpInput"}
            hasErrored={true}
            focusStyle="focus"
            autoFocus={true}
          />
          {error && <Form.Text>{errorMessage}</Form.Text>}
        </Form.Group>
        <Button
          type={"submit"}
          className={"w-100 btn-submit m-t-50"}
          disabled={disable}
        >
          Verify
        </Button>

        <div className="mainCounterDiv">
          {counter > 0 ? (
            <span className="d-inline-block mt-30">
              Resend in:{" "}
              <b className="timer blue-accent">
                {" "}
                00:{counter < 10 && "0"}
                {counter}
              </b>
            </span>
          ) : (
            <p
              onClick={() => resendCode()}
              className={"text-center blue-accent cursor-pointer passCodeLine"}
            >
              Didn’t get a<span className={"uLine"}>&nbsp;passode?</span>
            </p>
          )}
        </div>
      </Form>
    </div>
  );
};

export default VerifyEmail;
